import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Container, Grow, Grid, Paper, AppBar, TextField, Button } from '@material-ui/core'
//CSS
import useStyles from './styles'
//
import { getPosts, getPostBySearch } from '../../actions/posts'
import Posts from '../Posts/Posts'
import Form from '../Form/Form'
import Pagination from '../Pagination'
//
import { useHistory, useLocation } from 'react-router-dom'
import ChipInput from 'material-ui-chip-input'
//
function useQuery() {
	return new URLSearchParams(useLocation().search)
}
//
const Home = () => {
	//CSS
	const classes = useStyles()
	//HOOKS
	const dispatch = useDispatch()
	const [currentId, setCurrentId] = useState(null)
	const query = useQuery()
	const history = useHistory()
	const page = query.get('page') || 1
	const searchQuery = query.get('searchQuery')
	//GET ALL POSTS
	useEffect(() => {
		dispatch(getPosts(page))
	}, [dispatch])

	//GET SERACH INPUIT VALUR
	const [search, setSearch] = useState('')
	//GET SERACH TAGS
	const [tags, setTags] = useState([])
	const handleAdd = (tag) => setTags([...tags, tag])
	const handleDelete = (tagToDelete) => setTags(tags.filter((tag) => tag !== tagToDelete))
	const searchPost = () => {
		if (search.trim() || tags) {
			dispatch(getPostBySearch({ search, tags: tags.join(',') }))
			history.push(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`)
		} else {
			history.push('/')
		}
	}

	//SEARCH ON ENTER KEY PRESS
	const handleKeyPress = (e) => {
		if (e.keyCode === 13) {
			searchPost()
		}
	}
	return (
		<Grow in>
			<Container maxWidth='xl'>
				<Grid
					className={classes.gridContainer}
					container
					justifyContent='space-between'
					alignItems='stretch'
					spacing={3}
				>
					<Grid item xs={12} sm={6} md={9}>
						<Posts setCurrentId={setCurrentId} />
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<AppBar className={classes.appBarSearch} position='static' color='inherit'>
							<TextField
								name='search'
								variant='outlined'
								label='Search Memories'
								onKeyPress={handleKeyPress}
								fullWidth
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
							<ChipInput
								style={{ margin: '10px 0' }}
								value={tags}
								onAdd={handleAdd}
								onDelete={handleDelete}
								label='Search tags'
								variant='outlined'
							/>
							<Button
								onClick={searchPost}
								className={classes.searchButton}
								variant='contained'
								color='primary'
							>
								Search
							</Button>
						</AppBar>
						<Form setCurrentId={setCurrentId} currentId={currentId} />
						{!searchQuery && !tags.length && (
							<Paper className={classes.pagination} elevation={6}>
								<Pagination page={page} />
							</Paper>
						)}
					</Grid>
				</Grid>
			</Container>
		</Grow>
	)
}

export default Home
